export const ADD_TEAM = "ADD_TEAM";
export const REMOVE_TEAM = "REMOVE_TEAM";
export const ADD_MEMBER = "ADD_MEMBER";
export const REMOVE_MEMBER = "REMOVE_MEMBER";
export const EMPTY_STAGED_MEMBERS = "EMPTY_STAGED_MEMBERS";
export const EMPTY_STAGED_TEAMS = "EMPTY_STAGED_TEAMS";
export const ADD_ORGNIZATION = "ADD_ORGNIZATION";
export const REMOVE_ORGNIZATION = "REMOVE_ORGNIZATION";
export const EMPTY_STAGED_ORGNIZATIONS = "EMPTY_STAGED_ORGNIZATIONS";
export const UPDATE_FORM_DATA = "UPDATE_FORM_DATA";
export const UPDATE_OPTION = "UPDATE_OPTION";
export const SET_FORM_DATA = "SET_FORM_DATA";
export const SET_OPTIONS = "SET_OPTIONS";
export const SET_ACTIVE_STEP = "SET_ACTIVE_STEP";
export const SET_STAGED_TEAMS = "SET_STAGED_TEAMS";
export const SET_MEMBERS = "SET_MEMBERS";
export const SET_ORGNIZATIONS = "SET_ORGNIZATIONS";
export const SET_PACKAGE_MODE = "SET_PACKAGE_MODE";
export const SET_TEAM_MODE = "SET_TEAM_MODE";
export const SET_MEMBER_MODE = "SET_MEMBER_MODE";
export const SET_SELECTED_PACKAGE = "SET_SELECTED_PACKAGE";
export const SET_POINTS_GOAL_PER_DAY = "SET_POINTS_GOAL_PER_DAY";
